import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { EtatVide } from '../composants/EtatVide.js';
/** Mes formations — miroir des inscriptions Moodle (§5, §6.6). */
export function Formations({ t, urlCatalogue }) {
    return (_jsxs(_Fragment, { children: [_jsx("h1", { className: "titre-ecran", children: t('app.mesFormations') }), _jsx(EtatVide, { titre: t('etat.vide.titre'), texte: t('etat.vide.formations'), action: _jsx("a", { className: "etat-vide__action", href: urlCatalogue, children: t('nav.former') }) })] }));
}
//# sourceMappingURL=Formations.js.map